import React, { useState, useRef } from "react";
import Chevron from "./Chevron";
import ExpandIcon from "./ExpanIcon";
import MinusExpand from "./MinusExpand";
import styles from "./Accordion.module.css";

const Accordion = ({
  title,
  children,
  qaForm,
  isMobile,
  isTablet,
  retailerFromURL,
  isActive: controlledIsActive,
  onToggle,
}) => {
  const [internalIsActive, setInternalIsActive] = useState(false);
  const content = useRef(null);

  // Use controlled state if provided, otherwise use internal state
  const isActive = controlledIsActive !== undefined ? controlledIsActive : internalIsActive;

  const toggleAccordion = () => {
    if (onToggle) {
      onToggle();
    } else {
      setInternalIsActive(!internalIsActive);
    }
  };

  const contentHeight = isActive ? `${content.current?.scrollHeight}px` : "0px";

  return (
    <div
      className={[styles["accordion__section"], "accordion__section"].join(" ")}
      style={{
        "--section-max-width": retailerFromURL ? "80%" : "40%",
        "--section-width": retailerFromURL ? "80%" : "initial",
      }}
    >
      <button
        className={[styles["accordion"], "accordion", isActive ? styles["active"] : ""].join(" ")}
        onClick={toggleAccordion}
      >
        <span className={[styles["accordion__title"], "accordion__title"].join(" ")}>{title}</span>
        {qaForm ? (
          isActive ? (
            <MinusExpand
              className={`${styles["accordion__icon"]} ${isActive ? styles["rotate"] : ""}`}
              width={isMobile || isTablet ? 15 : 20}
              fill="#777"
            />
          ) : (
            <ExpandIcon
              className={`${styles["accordion__icon"]}`}
              width={isMobile || isTablet ? 15 : 20}
              fill="#777"
            />
          )
        ) : (
          <Chevron
            className={`${styles["accordion__icon"]} ${isActive ? styles["rotate"] : ""}`}
            width={20}
            fill="#777"
          />
        )}
      </button>
      <div
        ref={content}
        className={[styles["accordion__content"], "accordion__content"].join(" ")}
        style={{
          "--content-max-height": contentHeight,
        }}
      >
        <div className={[styles["accordion__text"], "accordion__text"].join(" ")}>{children}</div>
      </div>
    </div>
  );
};

export default Accordion;
